import { Grid } from '@mui/material';
import React from 'react';
import LabelWithIcon from '../../../common/ui/LabelWithIcon';
import FormInput from '../../../common/ui/Forms/FormInput/FormInput';
import PdfUpload from '../../../common/PdfUpload';
import { useTranslation } from 'react-i18next';

function Shops({
  control,
  register,
  errors,
  view = false,
  watch,
  setValue,
}: {
  control?: any;
  register: any;
  errors?: any;
  view?: boolean;
  watch: any;
  setValue: any;
}) {
  const { t } = useTranslation();
  return (
    <div>
      {' '}
      <Grid container display='flex' justifyContent='center'>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
          <LabelWithIcon
            label={t('LICENSE_NUMBER')}
            justifyContent='flex-start'
            className='mb-6  '
          />
          <FormInput
            name='shop_license_no'
            type='text'
            placeholder={t(`LICENSE_NUMBER`)}
            control={control}
            readOnly={view}
            className='input-from'
            rules={{
              required: {
                value: true,
                message: 'Please enter a license no..',
              },
            }}
            inputProps={{
              ...register('shop_license_no', {}),
            }}
            errors={errors}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
          <PdfUpload
            control={control}
            register={register}
            errors={errors}
            watch={watch}
            setValue={setValue}
            name={`shop_certificate`}
            errorName={`shop_certificate`}
            secondName={`shop_certificate`}
            labelName={t('CERTIFICATE')}
            errorMessage={t('PLEASER_SELECT_THE_CERTIFICATE')}
          />
        </Grid>
      </Grid>
    </div>
  );
}
export default Shops;
